export default function removeTrailingOrLeadingCharacter(
  str: string,
  character: string,
) {
  const leadingRegex = new RegExp(`^(\\${character})+`); // NOTE: the double backspaces are necessary to escape special characters like asterisks
  const trailingRegex = new RegExp(`(\\${character})+$`); // NOTE: the double backspaces are necessary to escape special characters like asterisks

  return str
    .replace(leadingRegex, '') // Remove leading character if there is a match
    .replace(trailingRegex, ''); // Remove trailing character if there is a match
}
